import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 8px;
  max-width: 100%;
  margin-bottom: 16px;
  padding: 0 16px;
  justify-content: space-between;
  flex-direction: column;
  border-radius: 4px;
  position: relative;
`;

export const FormSectionRow = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr 1fr 1fr 1fr;
  align-items: center;
  background-color: lightgrey;
  border-radius: 4px;
  padding: 16px;
  font-weight: bold;
`;

export const Comment = styled.textarea`
  background-color: lightgrey;
  border-radius: 4px;
  grid-column: 1/-1;
  padding: 8px;
  font-family: "HelveticaNowforMonksMedium";
  font-size: 16px;
  resize: vertical;
  margin-top: 16px;
  height: auto;

  &::-webkit-scrollbar {
    width: 7px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #242424;
    border-radius: 12px;
  }
`

export const ButtonComment = styled.button`
  width: 72px;
  display: flex;
  font-weight: bold;
  color: #fff;
  padding: 16px;
  border-radius: 8px;
  background-color: #f6be27;
  border: none;
  &:hover {
    background-color: #daa209; 
  };
  transition: all 0.3s ease-out;
  cursor: pointer;
  align-items: center;
  justify-self: flex-end;
  justify-content: center;
  gap: 4px;
  font-size: 20px;
`

export const Radio = styled.input`
    width: 24px;
    height: 24px;
    justify-self: center;
    cursor: pointer;
`

export const Icon = styled.img`
  width: 24px;
  pointer-events: none;
`

export const FormSectionHeader = styled.div`
  display: grid;
  grid-template-columns: 5fr 1fr 1fr 1fr 1fr;
  place-items: center;
  font-weight: bold;
  padding: 16px 32px;
`;

export const Hidden = styled.span`
  width: 100%;
  visibility: hidden;
`;

export const FormSectionLabel = styled.span`
  width: 60px;
  padding: 8px;
  justify-self: center;
  font-size: 12px;
  text-align: center;
  &:nth-child(4) {
    background-color: #ff0000;
  };
  &:nth-child(3) {
    background-color: #ffff00;
  };
  &:nth-child(2) {
    background-color: #00ff00;
  };
`;

export const TitleArea = styled.p`
  font-weight: bold;
  font-size: 32px;
  margin: 8px 0 0 0;
  padding: 16px;
  color: #fff;
  cursor: pointer;
`;
